import { AdminUserApi } from '@/api';
import { mapGetters } from 'vuex';
import { AdminUserMapping, MappingTools } from '@/mappings';
export default {
  components: {},
  data() {
    return {
      menu: [
        { key: 'dashboard', name: '仪表盘', path: '/dashboard', leaf: true },
        {
          key: 'employee',
          name: '客户管理',
          path: '/customer/list',
          leaf: true,
        },
        {
          key: 'enterprise',
          name: '企业管理',
          path: '/enterprise/list',
          leaf: true,
        },
        {
          key: 'workflow',
          name: '流程管理',
          path: '/workflow/list',
          leaf: true,
        },
        {
          key: 'warehouse',
          name: '资料库',
          path: '/warehouse',
          children: [
            {
              key: 'warehouseCustomer',
              name: '客户库',
              path: '/warehouse/customer',
              leaf: true,
            },
            {
              key: 'warehouseEnterprise',
              name: '企业库',
              path: '/warehouse/enterprise',
              leaf: true,
            },
          ],
        },
        {
          key: 'admin',
          name: '系统管理',
          path: '/admin',
          children: [
            {
              key: 'adminUser',
              name: '用户管理',
              path: '/admin/user/list',
              leaf: true,
            }, {
              key: 'catalogManager',
              name: '类目管理',
              path: '/setting/catalog/manager',
              leaf: true,
            }
          ],
        },
      ],
      changePasswordDialog: false,
      oldPassword: '',
      newPassword: '',
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  mounted() {
    console.log(this.$store);
  },
  watch: {},
  methods: {
    breadcrumb() {
      const matched = this.$route.matched;
      return matched
        .map((item) => item.name)
        .filter((name) => !!name)
        .join(' > ');
    },
    routerTo(menu) {
      this.$router.push(
        menu.children && menu.children.length
          ? menu.children[0].path
          : menu.path
      );
    },
    handleCommand(command) {
      switch (command) {
        case 'CHANGE_PASSWORD':
          this.changePasswordDialog = true;
          break;
        case 'LOGOUT':
          sessionStorage.setItem('authorization', '');
          location.hash = '/login';
          break;
        default:
          break;
      }
    },
    onChangePassword() {
      AdminUserApi.changePassword({
        old_password: this.oldPassword,
        new_password: this.newPassword,
      })
        .then(() => {
          this.$message.success('密码修改成功');
          sessionStorage.setItem('authorization', '');
          location.hash = '/login';
        })
        .catch((response) => {
          this.$message.error('操作失败：' + response.msg);
        });
    },
    matchUserLevelLabel(level) {
      return MappingTools.matchLabel(AdminUserMapping.Level, level);
    },
  },
};
